import commonEn from "./locales/en/common.json";
import commonEs from "./locales/es/common.json";
import commonSv from "./locales/sv/common.json";

/**
 * Collected translation resources from all colocated translation files.
 * Components with colocated translations dynamically register their namespaces.
 * Only common translations are loaded at startup.
 */
export const resources = {
  en: {
    common: commonEn,
  },
  es: {
    common: commonEs,
  },
  sv: {
    common: commonSv,
  },
};
